import { Col } from "reactstrap";
import LoginForm from "../Common/LoginForm";

const LoginWithSweetalertContainer = () => {
  return (
    <Col sm="12" className="p-0">
      <div className="login-card login-dark">
        <LoginForm logoClass="text-start" />
      </div>
    </Col>
  );
};

export default LoginWithSweetalertContainer;
